// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n1-0";
export var assigneeDetails = "_n1-1";
export var assigneeInfo = "_n1-2";
export var dropdownContainer = "_n1-4";
export var dropdownImage = "_n1-5";
export var editAssigneeInfo = "_n1-3";
export var editAssigneeModalContainer = "_n1-6";
export var hidden = "_n1-8";
export var input = "_n1-7";